











































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import { getCurrentUserId, isRoot } from "@/plugins/roles";

@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class ContractorListItem extends Vue {
  @Prop() contractor!: IContractorNew;
  @Prop({ default: true }) isHasAccessForActions?: boolean;
  isDeleteProcess: boolean = false;

  get root() {
    return isRoot();
  }

  deleteContractor() {
    this.isDeleteProcess = true;
    this.$emit("remove", this.contractor.id);
  }

  editContractor() {
    if (this.contractor.id)
      this.$router.push({
        name: "contractorItemEdit",
        params: {
          contractorId: this.contractor.id
        }
      });
  }

  get userId() {
    return getCurrentUserId();
  }
}
